export type BonusResultSubmission = {
  playerId: string;
  playerName: string;
  points: number;
};

export type BonusResultLeaderboardEntry = {
  playerId: string;
  playerName: string;
  score: number;
};

/**
 * Build a bonus-level-result-shaped payload from live player scores and pre-bonus baselines.
 * Used when the host missed bonus-level-result but room-state has updated totals.
 * Players without a captured baseline are skipped for gains (avoids treating full score as +N).
 */
export function buildFallbackBonusResult(
  players: Array<{ id: string; name: string; score: number }>,
  preBonusScores: Map<string, number>,
  questionId?: string
): {
  questionId?: string;
  submissions: BonusResultSubmission[];
  leaderboard: BonusResultLeaderboardEntry[];
} {
  const submissions = players
    .map((p) => {
      const pre = preBonusScores.get(p.id);
      const points = pre == null ? 0 : Math.max(0, p.score - pre);
      return {
        playerId: p.id,
        playerName: p.name,
        points,
      };
    })
    .sort((a, b) => b.points - a.points);

  return {
    questionId,
    submissions,
    leaderboard: players.map((p) => ({
      playerId: p.id,
      playerName: p.name,
      score: p.score,
    })),
  };
}
